// extracted by mini-css-extract-plugin
module.exports = {"cardHeader":"PaymentMethod_cardHeader_3_nYa","transparent":"PaymentMethod_transparent_1STA_","button":"PaymentMethod_button_1oSf_"};